import React from "react";
import cardImage from "../../assets/credit_card.png";
import { Colors } from "../../utils/colors";
import { TCText } from "../TCText/TCText";

type props = { cardNumber: string };

export const DefaultCardNumber: React.FC<props> = ({ cardNumber }) => {
  return (
    <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
      <img src={cardImage} alt="" style={{ height: 30, width: 30 }} />
      <TCText
        style={{ color: Colors.green, fontWeight: 600, fontSize: 15 }}
        value={cardNumber}
      />
    </div>
  );
};
